import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export enum EValidityStatus {
    IS_VALID = 'IS_VALID',
    IS_UPPER_BOUND_ERROR = 'IS_UPPER_BOUND_ERROR',
    IS_LOWER_BOUND_ERROR = 'IS_LOWER_BOUND_ERROR',
}

export type TPaymentSumValidity = {
    isValid: EValidityStatus.IS_VALID,
} | {
    isValid: EValidityStatus.IS_UPPER_BOUND_ERROR,
    maxPaymentSum: number,
} | {
    isValid: EValidityStatus.IS_LOWER_BOUND_ERROR,
    minPaymentSum: number,
}

export type TSetPaymentSumValidity = IAction<EPaymentActions.SET_PAYMENT_SUM_VALIDATION, TPaymentSumValidity>

const setPaymentSumValidity = (validationResult: TPaymentSumValidity): TSetPaymentSumValidity => ({
    type: EPaymentActions.SET_PAYMENT_SUM_VALIDATION,
    payload: validationResult,
});

export default setPaymentSumValidity;
